import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";
import LazyLoad from "vanilla-lazyload";

export default class extends Controller {
  static targets = ["image"];

  initialize() {
    this.imagesReady = 0;
  }

  connect() {
    this.imageTargets.forEach((el) => {
      el.style.opacity = 0;
    });

    this.lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy",
      callback_loaded: this.imageLoaded.bind(this),
    });
  }

  disconnect() {
    if (this.lazyLoadInstance) {
      this.lazyLoadInstance.destroy();
      this.lazyLoadInstance = null;
    }
  }

  imageLoaded() {
    this.imagesReady += 1;

    if (this.imagesReady === this.imageTargets.length) {
      this.showImages();
    }
  }

  showImages() {
    animate(this.imageTargets, {
      opacity: [0, 1],
      translateX: ["-10rem", "0"],
      duration: 1000,
      delay: (el, i) => i * 100,
      ease: "outCirc",
    });
  }
}
